import axios from "axios";
import { API } from "../context/AuthContext";

/**
 * Single canonical source for public service categories.
 * Everything (homepage chips, /services filters, business service form) reads
 * from GET /api/services/categories so the four surfaces can never drift apart
 * again. Slugs are stable and safe to put in URLs; labels are display-only.
 */
let cache = null;
let inflight = null;

export const CATEGORY_ICONS = {
  "auto-repair": "🚗",
  "home-repair": "🏠",
  cleaning: "🧼",
  hair: "💇",
  fitness: "🏋️",
  photography: "📸",
  tutoring: "📚",
  "private-chef": "🍳",
  "pet-grooming": "🐾",
  "event-planning": "🎉",
  other: "✨",
};

export async function fetchCategories() {
  if (cache) return cache;
  if (!inflight) {
    inflight = axios
      .get(`${API}/services/categories`)
      .then((r) => {
        cache = r.data?.categories || [];
        return cache;
      })
      .catch(() => [])
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

const slugify = (v) =>
  String(v || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

/** Accepts a slug, a display label, or a legacy label and returns a slug. */
export function toCategorySlug(value, categories) {
  if (!value) return "";
  const v = String(value).trim();
  if (!v || v.toLowerCase() === "all") return "";
  const list = categories || cache || [];
  const s = slugify(v);
  const bySlug = list.find((c) => c.slug === s);
  if (bySlug) return bySlug.slug;
  const byLabel = list.find((c) => slugify(c.label) === s);
  if (byLabel) return byLabel.slug;
  // Unknown to the client — hand it to the server, which resolves legacy aliases.
  return v;
}

export function categoryLabel(slug, categories) {
  const list = categories || cache || [];
  const hit = list.find((c) => c.slug === slug);
  return hit ? hit.label : "";
}

/** Chips worth showing: all fixed categories, plus "Other" only if populated. */
export function visibleCategories(categories) {
  return (categories || []).filter((c) => c.slug !== "other" || c.count > 0);
}
